<template>
  <div class="fullscreen">
    <div class="login-card">
      <div class="logo"><a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/">Normcore.</a></div>
      <form action="">
        <div>
          <label for="">Email</label><br>
          <input type="text">
        </div>
        <label for="">Password</label><br>
        <input type="password">
      </form>
      <div class="login-btn">
        <button href="#" v-on:click="login">Login</button>
      </div>
    </div>
    <div class="tiny-alt">Don't have an account? Sign up here.</div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: {

  },
  components: {

  },
  methods: {
    login: function() {
      console.log("we are loggin in");
      this.$router.push('home');
      this.$emit('updateUser', {id:1});
    }
  },
  beforeCreate: function() {
      document.body.className = 'login';
  },
  created() {
     //update app.vue with a fake user for now
    this.$emit('updateUser', {});
  },
  destroyed: function() {
      document.body.classList.remove('login');
  },
};
</script>

<style scoped lang="scss">
html body {
  background-color:red;
}

  .logo {
    margin-top: 40px;
    margin-bottom: 20px;
    a {
      text-decoration: none;
    }
  }
  label {
    margin-bottom: 10px;
    // font-family: "Poppins";
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
  }
  input {
    margin-top: 5px;
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    background-color: #1b1b1b;
    margin-bottom: 20px;
    color: white;
    width: 92%;
  }
  .fullscreen {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // background-color: black;
    // background-repeat: no-repeat;
    // background-position: center bottom;
    // background-image:url("/img/login-bg.png");
    // background-size: 120%;
  }

  .tiny-alt {
    font-size: 14px;
    // padding: 10px;
    color: white;
    opacity: 1;
    text-align: center;
    line-height: 1.3;
  }

  .login-card {
    // background-color: black;
    // color: white;
    // border:1px solid #eee;
    padding: 25px;
    // border-radius: 30px;
    width: 350px;
    height: 300px;
    // background-image: url("/img/login-bg.png");
    background-size: contain;


    // background-color: black;
    color: white;
  }

  .login-btn {
    text-align: right;
    margin-right: -11px;
    font-size: 20px;
    button {
      border-color: white;
      color: white;
      padding: 10px 30px;
      :hover {
        background-color: white;
      }
      // border-radius: 0;
    }
  }
  button:hover {
        background-color: white;
        color:black;

  }

</style>



